import { render, staticRenderFns } from "./SalesVolumeTrendCard.vue?vue&type=template&id=23983c34&"
import script from "./SalesVolumeTrendCard.vue?vue&type=script&lang=js&"
export * from "./SalesVolumeTrendCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports